/* RH Anleitung — Blätterbuch im Overlay.
   Aufruf:  RHAnleitung.oeffnen({titel, pdf, bildBasis, bilder:[…], texte:{de:[…],…}})
   Kein jQuery, keine Fremdbibliothek. */
(function () {
  "use strict";

  /* Textsprachen des Dokuments (Reihenfolge = Reihenfolge der Namen in TEXTE[…].namen) */
  var SPRACHEN = [
    { code: "de", fahne: "🇩🇪", eigen: "Deutsch" },
    { code: "en", fahne: "🇬🇧", eigen: "English" },
    { code: "fr", fahne: "🇫🇷", eigen: "Français" },
    { code: "es", fahne: "🇪🇸", eigen: "Español" },
    { code: "it", fahne: "🇮🇹", eigen: "Italiano" },
    { code: "nl", fahne: "🇳🇱", eigen: "Nederlands" },
    { code: "pl", fahne: "🇵🇱", eigen: "Polski" },
    { code: "cs", fahne: "🇨🇿", eigen: "Čeština" },
    { code: "sv", fahne: "🇸🇪", eigen: "Svenska" },
    { code: "hu", fahne: "🇭🇺", eigen: "Magyar" },
    { code: "ro", fahne: "🇷🇴", eigen: "Română" },
    { code: "el", fahne: "🇬🇷", eigen: "Ελληνικά" }
  ];

  /* Oberflaeche in allen 12 Shop-Sprachen, bewusst ohne Anrede */
  var TEXTE = {"de":{"wahl":"Sprache der Anleitung","hinweis":"Die bebilderte Bedienung ist in allen Sprachen beschriftet – die Wahl betrifft den Textteil.","pdf":"PDF herunterladen","pdf_voll":"Ganzes PDF (mehrsprachig)","zu":"Schließen","seite":"Seite","von":"von","fort":"Fortsetzung","sprache":"Sprache","zoom":"Vergrößern","zoom_zu":"Verkleinern","namen":["Deutsch","Englisch","Französisch","Spanisch","Italienisch"]},"en":{"wahl":"Manual language","hinweis":"The illustrated operating pages are labelled in every language – your choice applies to the text section.","pdf":"Download PDF","pdf_voll":"Full PDF (multilingual)","zu":"Close","seite":"Page","von":"of","fort":"continued","sprache":"Language","zoom":"Zoom in","zoom_zu":"Zoom out","namen":["German","English","French","Spanish","Italian"]},"fr":{"wahl":"Langue du manuel","hinweis":"Les pages illustrées sont légendées dans toutes les langues – le choix porte sur la partie texte.","pdf":"Télécharger le PDF","pdf_voll":"PDF complet (multilingue)","zu":"Fermer","seite":"Page","von":"sur","fort":"suite","sprache":"Langue","zoom":"Agrandir","zoom_zu":"Réduire","namen":["Allemand","Anglais","Français","Espagnol","Italien"]},"es":{"wahl":"Idioma del manual","hinweis":"Las páginas ilustradas están rotuladas en todos los idiomas: la elección afecta a la parte de texto.","pdf":"Descargar PDF","pdf_voll":"PDF completo (multilingüe)","zu":"Cerrar","seite":"Página","von":"de","fort":"continuación","sprache":"Idioma","zoom":"Ampliar","zoom_zu":"Reducir","namen":["Alemán","Inglés","Francés","Español","Italiano"]},"it":{"wahl":"Lingua del manuale","hinweis":"Le pagine illustrate sono etichettate in tutte le lingue: la scelta riguarda la parte testuale.","pdf":"Scarica il PDF","pdf_voll":"PDF completo (multilingue)","zu":"Chiudi","seite":"Pagina","von":"di","fort":"continua","sprache":"Lingua","zoom":"Ingrandisci","zoom_zu":"Riduci","namen":["Tedesco","Inglese","Francese","Spagnolo","Italiano"]},"nl":{"wahl":"Taal van de handleiding","hinweis":"De geïllustreerde bedieningspagina's zijn in alle talen gelabeld – de keuze geldt voor het tekstgedeelte.","pdf":"PDF downloaden","pdf_voll":"Volledige PDF (meertalig)","zu":"Sluiten","seite":"Pagina","von":"van","fort":"vervolg","sprache":"Taal","zoom":"Vergroten","zoom_zu":"Verkleinen","namen":["Duits","Engels","Frans","Spaans","Italiaans"]},"cs":{"wahl":"Jazyk návodu","hinweis":"Obrázkové stránky s ovládáním jsou popsané ve všech jazycích – volba se týká textové části.","pdf":"Stáhnout PDF","pdf_voll":"Celé PDF (vícejazyčné)","zu":"Zavřít","seite":"Strana","von":"z","fort":"pokračování","sprache":"Jazyk","zoom":"Zvětšit","zoom_zu":"Zmenšit","namen":["Němčina","Angličtina","Francouzština","Španělština","Italština"]},"pl":{"wahl":"Język instrukcji","hinweis":"Ilustrowane strony obsługi są opisane we wszystkich językach – wybór dotyczy części tekstowej.","pdf":"Pobierz PDF","pdf_voll":"Całe PDF (wielojęzyczne)","zu":"Zamknij","seite":"Strona","von":"z","fort":"ciąg dalszy","sprache":"Język","zoom":"Powiększ","zoom_zu":"Pomniejsz","namen":["Niemiecki","Angielski","Francuski","Hiszpański","Włoski"]},"sv":{"wahl":"Bruksanvisningens språk","hinweis":"De illustrerade sidorna är märkta på alla språk – valet gäller textdelen.","pdf":"Ladda ner PDF","pdf_voll":"Hela PDF:en (flerspråkig)","zu":"Stäng","seite":"Sida","von":"av","fort":"forts.","sprache":"Språk","zoom":"Förstora","zoom_zu":"Förminska","namen":["Tyska","Engelska","Franska","Spanska","Italienska"]},"hu":{"wahl":"A kézikönyv nyelve","hinweis":"A képes kezelési oldalak minden nyelven feliratozva vannak – a választás a szöveges részre vonatkozik.","pdf":"PDF letöltése","pdf_voll":"Teljes PDF (többnyelvű)","zu":"Bezárás","seite":"Oldal","von":"/","fort":"folytatás","sprache":"Nyelv","zoom":"Nagyítás","zoom_zu":"Kicsinyítés","namen":["Német","Angol","Francia","Spanyol","Olasz"]},"ro":{"wahl":"Limba manualului","hinweis":"Paginile ilustrate sunt etichetate în toate limbile – alegerea se aplică părții de text.","pdf":"Descarcă PDF","pdf_voll":"PDF complet (multilingv)","zu":"Închide","seite":"Pagina","von":"din","fort":"continuare","sprache":"Limbă","zoom":"Mărire","zoom_zu":"Micșorare","namen":["Germană","Engleză","Franceză","Spaniolă","Italiană"]},"el":{"wahl":"Γλώσσα του εγχειριδίου","hinweis":"Οι εικονογραφημένες σελίδες χειρισμού φέρουν επισημάνσεις σε όλες τις γλώσσες – η επιλογή αφορά το κείμενο.","pdf":"Λήψη PDF","pdf_voll":"Πλήρες PDF (πολύγλωσσο)","zu":"Κλείσιμο","seite":"Σελίδα","von":"από","fort":"συνέχεια","sprache":"Γλώσσα","zoom":"Μεγέθυνση","zoom_zu":"Σμίκρυνση","namen":["Γερμανικά","Αγγλικά","Γαλλικά","Ισπανικά","Ιταλικά"]}};

  var VERH = 439 / 306.125;      // Standard: Arizer-Faltblattseite
  var verh = VERH;               // tatsächliches Verhältnis (aus dem PDF übernommen)
  var REF  = 430;                // Referenzbreite für die Schriftskalierung
  var DAUER = 620;

  var cfg = null, schicht = null, buch = null, messer = null;
  var seiten = [], seitenGesamt = 0, pos = 0, sprache = "de", laeuft = false, breiteJetzt = 0;

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }
  var ober = "de";                       /* Sprache der Oberflaeche (Shop-Sprache) */
  function t(schluessel) {
    var w = TEXTE[ober] || TEXTE.en;
    return (w && w[schluessel]) || (TEXTE.en && TEXTE.en[schluessel]) || schluessel;
  }
  function sprachName(code) {
    try {                                    /* der Browser kennt die Sprachnamen selbst */
      var d = new Intl.DisplayNames([ober], { type: "language" });
      var n = d.of(code);
      if (n && n !== code) return n.charAt(0).toUpperCase() + n.slice(1);
    } catch (e) {}
    var reihe = ["de", "en", "fr", "es", "it"];
    var i = reihe.indexOf(code);
    var w = TEXTE[ober] || TEXTE.en;
    return (i >= 0 && w.namen && w.namen[i]) || code;
  }
  function doppelseitig() { return window.innerWidth >= 820; }

  /* Sprachen, die dieses Handbuch anbietet (Blöcke im PDF oder eigene Texte) */
  function angebot() {
    return SPRACHEN.filter(function (s) {
      return cfg.bloecke ? !!cfg.bloecke[s.code]
                         : !!(cfg.texte && cfg.texte[s.code] && cfg.texte[s.code].length);
    });
  }

  /* ---------- Aufbau der Oberfläche ---------- */

  function bauen() {
    schicht = el("div", "rh-ab-schicht");
    schicht.setAttribute("role", "dialog");
    schicht.setAttribute("aria-modal", "true");

    var kopf = el("div", "rh-ab-kopf");
    kopf.appendChild(el("div", "rh-ab-titel", cfg.titel || "Bedienungsanleitung"));
    var unter = el("div", "rh-ab-untertitel", "");
    kopf.appendChild(unter);
    var rechts = el("div", "rh-ab-rechts");

    var wechsel = el("button", "rh-ab-knopf rh-ab-sprachwechsel", t("sprache"));
    wechsel.addEventListener("click", zurueckZurWahl);
    rechts.appendChild(wechsel);

    var laden = el("a", "rh-ab-knopf rh-ab-voll", window.innerWidth < 560 ? "PDF" : t("pdf"));
    laden.href = cfg.pdf; laden.target = "_blank"; laden.rel = "noopener";
    if (cfg.pdfName) laden.setAttribute("download", cfg.pdfName);
    rechts.appendChild(laden);

    var zu = el("button", "rh-ab-knopf rh-ab-schliessen", "×");
    zu.setAttribute("aria-label", t("zu"));
    zu.addEventListener("click", schliessen);
    rechts.appendChild(zu);

    kopf.appendChild(rechts);
    schicht.appendChild(kopf);
    schicht._unter = unter;
    schicht._wechsel = wechsel;

    schicht.appendChild(sprachwahlBauen());

    var buehne = el("div", "rh-ab-buehne");
    buch = el("div", "rh-ab-buch");
    buch.appendChild(el("div", "rh-ab-seite rh-ab-li rh-ab-zoombar"));
    buch.appendChild(el("div", "rh-ab-seite rh-ab-re rh-ab-zoombar"));
    var tZ = el("div", "rh-ab-tipp rh-ab-zurueck");
    var tV = el("div", "rh-ab-tipp rh-ab-vor");
    tZ.addEventListener("click", function () { blaettern(-1); });
    tV.addEventListener("click", function () { blaettern(1); });
    buch.appendChild(tZ); buch.appendChild(tV);
    buch.querySelector(".rh-ab-li").addEventListener("dblclick", function () { lupeOeffnen(pos); });
    buch.querySelector(".rh-ab-re").addEventListener("dblclick", function () {
      lupeOeffnen(doppelseitig() ? pos + 1 : pos);
    });
    buehne.appendChild(buch);
    schicht.appendChild(buehne);

    var steuer = el("div", "rh-ab-steuer");
    var zurueck = el("button", "rh-ab-knopf rh-ab-pfeil", "‹");
    var vor = el("button", "rh-ab-knopf rh-ab-pfeil", "›");
    var stand = el("div", "rh-ab-stand", "");
    zurueck.addEventListener("click", function () { blaettern(-1); });
    vor.addEventListener("click", function () { blaettern(1); });
    var lupeAuf = el("button", "rh-ab-knopf rh-ab-pfeil rh-ab-lupenknopf", "⌕");
    lupeAuf.addEventListener("click", function () {
      lupeOeffnen(doppelseitig() ? pos + 1 : pos);
    });
    steuer.appendChild(zurueck); steuer.appendChild(stand); steuer.appendChild(vor);
    steuer.appendChild(lupeAuf);
    schicht.appendChild(steuer);
    schicht._zurueck = zurueck; schicht._vor = vor; schicht._stand = stand;

    messer = el("div", "rh-ab-seite");
    messer.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;left:-9999px;top:0;";
    schicht.appendChild(messer);

    schicht.addEventListener("click", function (e) {
      if (e.target === schicht) schliessen();
    });
    document.body.appendChild(schicht);

    document.addEventListener("keydown", tasten);
    window.addEventListener("resize", beiGroesse);
    wischen(buch);
  }

  function sprachwahlBauen() {
    var karte = el("div", "rh-ab-wahl");
    karte.appendChild(el("h2", null, t("wahl")));
    karte.appendChild(el("p", null, t("hinweis")));
    var liste = el("div", "rh-ab-sprachen");
    SPRACHEN.forEach(function (s) {
      if (angebot().indexOf(s) < 0) return;
      var k = el("button", "rh-ab-sprache");
      k.appendChild(el("span", "rh-ab-fahne", s.fahne));
      var w = el("span");
      w.appendChild(el("b", null, s.eigen));
      w.appendChild(el("span", null, sprachName(s.code)));
      k.appendChild(w);
      k.addEventListener("click", function () { lesen(s.code); });
      liste.appendChild(k);
    });
    karte.appendChild(liste);

    var fuss = el("div", "rh-ab-fuss");
    var laden = el("a", "rh-ab-knopf", "⤓ " + t("pdf_voll"));
    laden.href = cfg.pdf; laden.target = "_blank"; laden.rel = "noopener";
    fuss.appendChild(laden);
    karte.appendChild(fuss);
    return karte;
  }

  /* ---------- PDF-Quelle ---------- */

  var pdfDoc = null, pdfLaedt = null, pdfCache = {}, pdfAuftrag = {};

  function pdfLaden() {
    if (pdfDoc) return Promise.resolve(pdfDoc);
    if (pdfLaedt) return pdfLaedt;
    var lib = window.pdfjsLib;
    if (!lib) return Promise.reject(new Error("pdfjsLib fehlt"));
    if (cfg.arbeiter) lib.GlobalWorkerOptions.workerSrc = cfg.arbeiter;
    pdfLaedt = lib.getDocument({
      url: cfg.pdf,
      rangeChunkSize: 262144,          /* 256 KB je Nachladung */
      disableAutoFetch: true,          /* nur holen, was gebraucht wird */
      disableStream: false
    }).promise.then(function (doc) {
      pdfDoc = doc;
      if (cfg.format && cfg.format[0] > 0) {
        verh = cfg.format[1] / cfg.format[0];   /* häufigstes Format als Rahmen */
        return doc;
      }
      return doc.getPage(1).then(function (seite) {
        var v = seite.getViewport({ scale: 1 });
        verh = v.height / v.width;
        return doc;
      });
    });
    return pdfLaedt;
  }

  /* Eine PDF-Seite in einen Seitenknoten zeichnen. */
  function pdfZeichnen(knoten, nr, kennung) {
    if (!pdfDoc) return;
    var b = breiteJetzt;
    var dicht = Math.min(window.devicePixelRatio || 1, 2);
    var schluessel = nr + "@" + Math.round(b) + "x" + dicht;
    if (pdfCache[schluessel]) {
      knoten.appendChild(pdfCache[schluessel].cloneNode(false));
      malen(knoten, pdfCache[schluessel]);
      return;
    }
    var alt = pdfAuftrag[kennung];
    if (alt && alt.cancel) { try { alt.cancel(); } catch (e) {} }

    pdfDoc.getPage(nr).then(function (seite) {
      var eins = seite.getViewport({ scale: 1 });
      var rahmenB = b, rahmenH = b * verh;
      /* Seite in den Buchrahmen einpassen — so vertragen sich auch Handbücher,
         deren Seiten unterschiedlich hoch sind (Faltblätter, Web-Ausgaben). */
      var passung = Math.min(rahmenB / eins.width, rahmenH / eins.height);
      var sicht = seite.getViewport({ scale: passung * dicht });
      var leinwand = document.createElement("canvas");
      leinwand.width = Math.round(rahmenB * dicht);
      leinwand.height = Math.round(rahmenH * dicht);
      leinwand.style.width = "100%";
      leinwand.style.height = "100%";
      leinwand.style.display = "block";
      var stift = leinwand.getContext("2d");
      stift.fillStyle = "#fff";
      stift.fillRect(0, 0, leinwand.width, leinwand.height);
      stift.translate(Math.round((leinwand.width - sicht.width) / 2),
                      Math.round((leinwand.height - sicht.height) / 2));
      var auftrag = seite.render({ canvasContext: stift, viewport: sicht });
      pdfAuftrag[kennung] = auftrag;
      return auftrag.promise.then(function () {
        pdfCache[schluessel] = leinwand;
        if (Object.keys(pdfCache).length > 24) {      /* Cache klein halten */
          var raus = Object.keys(pdfCache).slice(0, 8);
          raus.forEach(function (k) { delete pdfCache[k]; });
        }
        if (knoten.dataset.rhSeite === String(nr)) {
          knoten.innerHTML = "";
          knoten.appendChild(leinwand);
        }
      });
    }).catch(function (e) {
      if (e && e.name === "RenderingCancelledException") return;
    });
  }

  function malen(knoten, leinwand) {
    knoten.innerHTML = "";
    var kopie = document.createElement("canvas");
    kopie.width = leinwand.width; kopie.height = leinwand.height;
    kopie.style.width = "100%"; kopie.style.height = "100%"; kopie.style.display = "block";
    kopie.getContext("2d").drawImage(leinwand, 0, 0);
    knoten.appendChild(kopie);
  }

  /* ---------- Seitenmodell ---------- */

  function seitenBauen(code) {
    var s = [];
    /* Die leere Umschlaginnenseite gibt es nur im aufgeschlagenen Buch;
       am Telefon wird einzeln geblättert und beginnt direkt beim Deckblatt. */
    if (doppelseitig()) s.push({ typ: "leer", nr: null });
    if (cfg.pdf && pdfDoc && !cfg.bilder) {
      var bereich = cfg.bloecke && code ? cfg.bloecke[code] : null;
      if (bereich) {
        /* Titelseiten plus der Block dieser Sprache */
        (cfg.titelSeiten || []).forEach(function (n) { s.push({ typ: "pdf", pdfNr: n }); });
        for (var n = bereich[0]; n <= bereich[1]; n++) { s.push({ typ: "pdf", pdfNr: n }); }
      } else {
        /* keine Sprachtrennung im Dokument: ganzes Buch */
        for (var m = 1; m <= pdfDoc.numPages; m++) { s.push({ typ: "pdf", pdfNr: m }); }
      }
    } else {
      (cfg.bilder || []).forEach(function (b) {
        s.push({ typ: "bild", src: (cfg.bildBasis || "") + b });
      });
      var kapitel = (cfg.texte && cfg.texte[code]) || [];
      kapitel.forEach(function (k) {
        umbrechen(k).forEach(function (seite) { s.push(seite); });
      });
    }
    if (doppelseitig() && s.length % 2 !== 0) s.push({ typ: "leer", nr: null });
    var zaehler = 0;
    s.forEach(function (seite) {
      seite.nr = seite.typ === "leer" ? null : ++zaehler;
    });
    seitenGesamt = zaehler;
    return s;
  }

  /* Kapiteltext satzweise auf Seiten verteilen — misst im echten Seitenformat. */
  function umbrechen(kapitel) {
    var saetze = kapitel.text.split(/(?<=[.!?:])\s+/).filter(function (x) { return x.trim(); });
    var raus = [], i = 0, fortsetzung = false;
    var schutz = 0;
    while (i < saetze.length && schutz++ < 400) {
      var titel = fortsetzung ? kapitel.titel : kapitel.titel;
      var genommen = fuellen(titel, fortsetzung, saetze, i);
      if (genommen <= 0) genommen = 1;                          // Notbremse
      raus.push({
        typ: "text", titel: titel, fort: fortsetzung,
        text: saetze.slice(i, i + genommen).join(" ")
      });
      i += genommen;
      fortsetzung = true;
    }
    return raus;
  }

  /* wie viele Sätze passen ab Index i auf eine Seite? */
  function fuellen(titel, fort, saetze, i) {
    messer.innerHTML = "";
    var box = el("div", "rh-ab-text");
    box.lang = sprache;
    var h = el("h3", fort ? "rh-ab-fort" : null, fort ? titel + " (" + t("fort") + ")" : titel);
    var p = el("p");
    box.appendChild(h); box.appendChild(p);
    messer.appendChild(box);

    var passt = 0, text = "";
    for (var n = i; n < saetze.length; n++) {
      var neu = text ? text + " " + saetze[n] : saetze[n];
      p.textContent = neu;
      if (box.scrollHeight > box.clientHeight) break;
      text = neu; passt = n - i + 1;
    }
    messer.innerHTML = "";
    return passt;
  }

  /* ---------- Zeichnen ---------- */

  function seiteFuellen(knoten, daten, nr) {
    knoten.innerHTML = "";
    if (!daten || daten.typ === "leer") { knoten.style.background = "#f6f7f6"; return; }
    knoten.style.background = "#fff";
    if (daten.typ === "pdf") {
      knoten.dataset.rhSeite = String(daten.pdfNr);
      pdfZeichnen(knoten, daten.pdfNr, knoten.className);
      return;
    }
    if (daten.typ === "bild") {
      var img = new Image();
      img.src = bildUrl(daten.src);
      img.alt = "";
      img.loading = "eager";
      knoten.appendChild(img);
    } else {
      var box = el("div", "rh-ab-text");
      box.lang = sprache;
      box.appendChild(el("h3", daten.fort ? "rh-ab-fort" : null,
        daten.fort ? daten.titel + " (" + t("fort") + ")" : daten.titel));
      box.appendChild(el("p", null, daten.text));
      knoten.appendChild(box);
      if (nr) knoten.appendChild(el("div", "rh-ab-nr", String(nr)));
    }
  }

  function masseSetzen() {
    var doppel = doppelseitig();
    var wVerf = window.innerWidth - (doppel ? 48 : 16);
    var hVerf = window.innerHeight - (doppel ? 150 : 126);
    var b = Math.min(doppel ? wVerf / 2 : wVerf, hVerf / verh);
    b = Math.max(160, Math.floor(b));
    var h = Math.round(b * verh);
    breiteJetzt = b;
    var skala = b / REF;
    buch.style.setProperty("--rh-ab-b", b + "px");
    buch.style.setProperty("--rh-ab-h", h + "px");
    buch.style.setProperty("--rh-ab-s", skala);
    [].forEach.call(buch.querySelectorAll(".rh-ab-seite"), function (s) {
      s.style.width = b + "px"; s.style.height = h + "px";
    });
    messer.style.width = b + "px"; messer.style.height = h + "px";
    messer.style.setProperty("--rh-ab-s", skala);
    return { b: b, h: h };
  }

  function zeichnen() {
    var doppel = doppelseitig();
    var li = buch.querySelector(".rh-ab-li"), re = buch.querySelector(".rh-ab-re");
    if (doppel) {
      seiteFuellen(li, seiten[pos], pos);
      seiteFuellen(re, seiten[pos + 1], pos + 1);
    } else {
      seiteFuellen(re, seiten[pos], pos);
    }
    var links = seiten[pos] && seiten[pos].nr;
    var rechts = seiten[pos + 1] && seiten[pos + 1].nr;
    var nr;
    if (!doppel) { nr = String(links || ""); }
    else if (links && rechts) { nr = links + " – " + rechts; }
    else { nr = String(links || rechts || ""); }
    schicht._stand.textContent = t("seite") + " " + nr + " " + t("von") + " " + seitenGesamt;
    schicht._zurueck.disabled = pos <= 0;
    schicht._vor.disabled = pos + (doppel ? 2 : 1) > seiten.length - 1;
    vorladen();
  }

  /* Shopify liefert das Bild in der Breite, die die Seite gerade braucht. */
  function bildUrl(src) {
    if (!src || src.indexOf("cdn.shopify.com") < 0) return src;
    var dicht = window.devicePixelRatio || 1;
    var w = Math.ceil((breiteJetzt * Math.min(dicht, 2)) / 100) * 100;
    w = Math.min(1400, Math.max(500, w || 900));
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }

  function vorladen() {
    for (var n = pos + 1; n <= pos + 4 && n < seiten.length; n++) {
      var s = seiten[n];
      if (s && s.typ === "bild") { var i = new Image(); i.src = bildUrl(s.src); }
      else if (s && s.typ === "pdf" && pdfDoc) { pdfDoc.getPage(s.pdfNr); }
    }
  }

  /* ---------- Blättern ---------- */

  function blaettern(richtung) {
    if (laeuft) return;
    var doppel = doppelseitig(), schritt = doppel ? 2 : 1;
    var neu = pos + richtung * schritt;
    if (neu < 0 || neu >= seiten.length) return;

    if (!doppel) { pos = neu; zeichnen(); return; }

    laeuft = true;
    var b = breiteJetzt, h = Math.round(b * verh);
    var li = buch.querySelector(".rh-ab-li"), re = buch.querySelector(".rh-ab-re");

    var blatt = el("div", "rh-ab-blatt");
    blatt.style.width = b + "px"; blatt.style.height = h + "px";
    blatt.style.left = b + "px";                 // rechte Buchhälfte
    blatt.style.transformOrigin = "left center";
    var vorn = el("div", "rh-ab-flaeche rh-ab-vorn");
    var hinten = el("div", "rh-ab-flaeche rh-ab-hinten");
    blatt.appendChild(vorn); blatt.appendChild(hinten);

    if (richtung > 0) {
      seiteFuellen(vorn, seiten[pos + 1], pos + 1);
      seiteFuellen(hinten, seiten[pos + 2], pos + 2);
      seiteFuellen(re, seiten[pos + 3], pos + 3);          // kommt darunter zum Vorschein
      blatt.style.transform = "rotateY(0deg)";
      buch.appendChild(blatt);
      blatt.offsetWidth;                                    // Layout erzwingen
      blatt.classList.add("rh-ab-laeuft");
      blatt.style.transform = "rotateY(-180deg)";
    } else {
      seiteFuellen(vorn, seiten[pos - 1], pos - 1);
      seiteFuellen(hinten, seiten[pos], pos);
      seiteFuellen(li, seiten[pos - 2], pos - 2);
      blatt.style.transform = "rotateY(-180deg)";
      buch.appendChild(blatt);
      blatt.offsetWidth;
      blatt.classList.add("rh-ab-laeuft");
      blatt.style.transform = "rotateY(0deg)";
    }

    window.setTimeout(function () {
      if (blatt.parentNode) blatt.parentNode.removeChild(blatt);
      pos = neu;
      laeuft = false;
      zeichnen();
    }, DAUER);
  }

  /* ---------- Lupe ---------- */

  var lupe = null, lupeBuehne = null, lupeStand = null, lupeSeite = 0;
  var lk = 1, lx = 0, ly = 0;                 /* Faktor und Verschiebung */

  function lupeBauen() {
    lupe = el("div", "rh-ab-lupe");
    lupeBuehne = el("div", "rh-ab-lupe-buehne");
    lupe.appendChild(lupeBuehne);
    lupeStand = el("div", "rh-ab-lupe-hinweis", "");
    lupe.appendChild(lupeStand);

    var leiste = el("div", "rh-ab-lupe-leiste");
    var zurueck = el("button", "rh-ab-knopf rh-ab-pfeil", "‹");
    var raus = el("button", "rh-ab-knopf rh-ab-pfeil", "−");
    var rein = el("button", "rh-ab-knopf rh-ab-pfeil", "+");
    var vor = el("button", "rh-ab-knopf rh-ab-pfeil", "›");
    var zu = el("button", "rh-ab-knopf", t("zu"));
    zurueck.addEventListener("click", function () { lupeSpringen(-1); });
    vor.addEventListener("click", function () { lupeSpringen(1); });
    rein.addEventListener("click", function () { lupeZoom(lk * 1.4); });
    raus.addEventListener("click", function () { lupeZoom(lk / 1.4); });
    zu.addEventListener("click", lupeSchliessen);
    [zurueck, raus, rein, vor, zu].forEach(function (k) { leiste.appendChild(k); });
    lupe.appendChild(leiste);

    lupeGesten();
    schicht.appendChild(lupe);
  }

  function lupeOeffnen(index) {
    if (!lupe) lupeBauen();
    lupeSeite = Math.max(0, Math.min(seiten.length - 1, index));
    if (seiten[lupeSeite] && seiten[lupeSeite].typ === "leer" && seiten[lupeSeite + 1]) lupeSeite++;
    schicht.classList.add("rh-ab-lupt");   /* erst sichtbar, sonst misst clientHeight 0 */
    lupeZeichnen();
  }

  function lupeSchliessen() {
    schicht.classList.remove("rh-ab-lupt");
  }

  function lupeSpringen(richtung) {
    var n = lupeSeite + richtung;
    while (seiten[n] && seiten[n].typ === "leer") { n += richtung; }
    if (n < 0 || n >= seiten.length) return;
    lupeSeite = n;
    lupeZeichnen();
  }

  function lupeZeichnen() {
    var daten = seiten[lupeSeite];
    var b = breiteJetzt, h = Math.round(b * verh);
    lupeBuehne.style.width = b + "px";
    lupeBuehne.style.height = h + "px";
    lupeBuehne.style.setProperty("--rh-ab-s", b / REF);
    lupeBuehne.innerHTML = "";
    if (daten && daten.typ === "pdf") {
      lupeBuehne.dataset.rhSeite = String(daten.pdfNr);
      pdfZeichnen(lupeBuehne, daten.pdfNr, "lupe");
    } else if (daten && daten.typ === "bild") {
      var img = new Image();
      /* in der Lupe die grosse Fassung holen, damit es beim Zoomen scharf bleibt */
      img.src = daten.src.indexOf("cdn.shopify.com") >= 0
        ? daten.src + (daten.src.indexOf("?") >= 0 ? "&" : "?") + "width=1600"
        : daten.src;
      lupeBuehne.appendChild(img);
    } else if (daten && daten.typ === "text") {
      var box = el("div", "rh-ab-text");
      box.lang = sprache;
      box.appendChild(el("h3", daten.fort ? "rh-ab-fort" : null,
        daten.fort ? daten.titel + " (" + t("fort") + ")" : daten.titel));
      box.appendChild(el("p", null, daten.text));
      lupeBuehne.appendChild(box);
    }
    if (lupeStand) {
      var d = seiten[lupeSeite];
      lupeStand.textContent = d && d.nr
        ? t("seite") + " " + d.nr + " " + t("von") + " " + seitenGesamt : "";
    }
    /* Startgroesse: Seite fuellt die Hoehe */
    var freiH = lupe.clientHeight - 104;     /* Leiste unten + Luft oben */
    var freiB = lupe.clientWidth - 16;
    /* Die Faltblatt-Spalte ist ab etwa 760 px lesbar. So weit wird hineingezoomt,
       mindestens aber so, dass die Seite die Flaeche fuellt. */
    var einpassen = Math.min(freiH / h, freiB / b);
    /* Nur Bildseiten brauchen Zoom — dort steckt die Schrift im Bild.
       Textseiten sind auf Seitenbreite gesetzt und werden nur eingepasst. */
    var istBild = daten && (daten.typ === "bild" || daten.typ === "pdf");
    var lesbar = istBild ? Math.min(3.2, 760 / b) : einpassen;
    lk = Math.max(einpassen, lesbar);
    if (lk > einpassen + 0.01) {             /* groesser als die Flaeche: oben links anfangen */
      lx = Math.max(0, (b * lk - lupe.clientWidth) / 2);
      ly = Math.max(0, (h * lk - freiH) / 2);
    } else {
      lx = 0; ly = 0;
    }
    lupeSetzen();
  }

  function lupeSetzen() {
    var b = breiteJetzt, h = Math.round(b * verh);
    var grenzeX = Math.max(0, (b * lk - lupe.clientWidth) / 2 + 20);
    var grenzeY = Math.max(0, (h * lk - lupe.clientHeight) / 2 + 40);
    lx = Math.max(-grenzeX, Math.min(grenzeX, lx));
    ly = Math.max(-grenzeY, Math.min(grenzeY, ly));
    lupeBuehne.style.transform =
      "translate(-50%,-50%) translate(" + lx + "px," + ly + "px) scale(" + lk + ")";
  }

  function lupeZoom(neu, ankerX, ankerY) {
    var vorher = lk;
    lk = Math.max(0.8, Math.min(6, neu));
    if (ankerX != null) {         /* zum Mauszeiger zoomen */
      var f = lk / vorher;
      lx = ankerX - (ankerX - lx) * f;
      ly = ankerY - (ankerY - ly) * f;
    }
    lupeSetzen();
  }

  function lupeGesten() {
    var zieht = false, sx = 0, sy = 0, startX = 0, startY = 0;
    var fingerAbstand = 0, fingerFaktor = 1;

    lupe.addEventListener("wheel", function (e) {
      e.preventDefault();
      var r = lupe.getBoundingClientRect();
      lupeZoom(lk * (e.deltaY < 0 ? 1.12 : 1 / 1.12),
               e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2);
    }, { passive: false });

    lupe.addEventListener("mousedown", function (e) {
      if (e.target.closest(".rh-ab-lupe-leiste")) return;
      zieht = true; sx = e.clientX; sy = e.clientY; startX = lx; startY = ly;
      lupe.classList.add("rh-ab-zieht"); lupe.classList.add("rh-ab-bewegt");
    });
    window.addEventListener("mousemove", function (e) {
      if (!zieht) return;
      lx = startX + (e.clientX - sx); ly = startY + (e.clientY - sy); lupeSetzen();
    });
    window.addEventListener("mouseup", function () {
      zieht = false;
      lupe.classList.remove("rh-ab-zieht"); lupe.classList.remove("rh-ab-bewegt");
    });
    lupe.addEventListener("dblclick", function (e) {
      if (e.target.closest(".rh-ab-lupe-leiste")) return;
      lupeZoom(lk > 1.8 ? 1 : 2.6);
    });

    lupe.addEventListener("touchstart", function (e) {
      if (e.target.closest(".rh-ab-lupe-leiste")) return;
      lupe.classList.add("rh-ab-bewegt");
      if (e.touches.length === 1) {
        zieht = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        startX = lx; startY = ly;
      } else if (e.touches.length === 2) {
        zieht = false;
        fingerAbstand = abstand(e.touches); fingerFaktor = lk;
      }
    }, { passive: true });

    lupe.addEventListener("touchmove", function (e) {
      if (e.touches.length === 2 && fingerAbstand) {
        e.preventDefault();
        lupeZoom(fingerFaktor * (abstand(e.touches) / fingerAbstand));
      } else if (zieht && e.touches.length === 1) {
        e.preventDefault();
        lx = startX + (e.touches[0].clientX - sx);
        ly = startY + (e.touches[0].clientY - sy);
        lupeSetzen();
      }
    }, { passive: false });

    lupe.addEventListener("touchend", function (e) {
      if (e.touches.length === 0) {
        zieht = false; fingerAbstand = 0; lupe.classList.remove("rh-ab-bewegt");
      }
    }, { passive: true });
  }

  function abstand(b) {
    var dx = b[0].clientX - b[1].clientX, dy = b[0].clientY - b[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  /* ---------- Bedienung ---------- */

  function tasten(e) {
    if (!schicht || !schicht.classList.contains("auf")) return;
    if (e.key === "Escape") {
      if (schicht.classList.contains("rh-ab-lupt")) { lupeSchliessen(); } else { schliessen(); }
      return;
    }
    if (schicht.classList.contains("rh-ab-lupt")) {
      if (e.key === "ArrowRight") { e.preventDefault(); lupeSpringen(1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); lupeSpringen(-1); }
      if (e.key === "+" || e.key === "=") { lupeZoom(lk * 1.4); }
      if (e.key === "-") { lupeZoom(lk / 1.4); }
      return;
    }
    if (!schicht.classList.contains("liest")) return;
    if (e.key === "ArrowRight" || e.key === "PageDown") { e.preventDefault(); blaettern(1); }
    if (e.key === "ArrowLeft" || e.key === "PageUp") { e.preventDefault(); blaettern(-1); }
    if (e.key === "Home") { pos = 0; zeichnen(); }
    if (e.key === "End") { pos = seiten.length - (doppelseitig() ? 2 : 1); zeichnen(); }
  }

  function wischen(ziel) {
    var x0 = null, y0 = null, letzterTipp = 0;
    ziel.addEventListener("touchstart", function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      var jetzt = Date.now();
      if (jetzt - letzterTipp < 320) {          /* Doppeltipp -> Lupe */
        letzterTipp = 0; x0 = null;
        lupeOeffnen(doppelseitig() ? pos + 1 : pos);
        return;
      }
      letzterTipp = jetzt;
    }, { passive: true });
    ziel.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy)) blaettern(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  var groesseTimer = null;
  function beiGroesse() {
    if (!schicht || !schicht.classList.contains("liest")) return;
    window.clearTimeout(groesseTimer);
    groesseTimer = window.setTimeout(function () {
      var pdfKnopf = schicht.querySelector(".rh-ab-kopf .rh-ab-voll");
      if (pdfKnopf) pdfKnopf.textContent = window.innerWidth < 560 ? "PDF" : t("pdf");
      masseSetzen();
      seiten = seitenBauen(sprache);
      if (doppelseitig() && pos % 2 !== 0) pos--;
      if (pos >= seiten.length) pos = 0;
      zeichnen();
    }, 180);
  }

  function lesen(code) {
    sprache = code || "de";
    schicht.classList.add("liest");
    var s = SPRACHEN.filter(function (x) { return x.code === code; })[0];
    schicht._unter.textContent = s ? s.eigen : "";
    schicht._wechsel.style.display = angebot().length > 1 ? "" : "none";
    /* Bildseiten haben Vorrang: dort ist die PDF-Adresse nur der Download-Knopf. */
    if (cfg.pdf && !cfg.bilder) {
      laden(true);
      pdfLaden().then(function () { laden(false); aufbauen(); })
                .catch(function (e) { laden(false, String(e && e.message || e)); });
    } else {
      aufbauen();
    }
  }

  function aufbauen() {
    masseSetzen();
    seiten = seitenBauen(sprache);
    pos = 0;
    zeichnen();
  }

  function laden(an, fehler) {
    var k = schicht.querySelector(".rh-ab-laedt");
    if (!k) {
      k = el("div", "rh-ab-laedt");
      k.appendChild(el("div", "rh-ab-kringel"));
      schicht.appendChild(k);
    }
    k.style.display = an || fehler ? "flex" : "none";
    if (fehler) { k.textContent = fehler; }
  }

  function zurueckZurWahl() {
    schicht.classList.remove("liest");
    schicht._unter.textContent = "";
  }

  function schliessen() {
    if (!schicht) return;
    schicht.classList.remove("auf");
    document.documentElement.style.overflow = "";
    window.setTimeout(function () { schicht.classList.remove("liest"); }, 260);
  }

  window.RHAnleitung = {
    oeffnen: function (einstellungen) {
      cfg = einstellungen || {};
      var l = (cfg.locale || document.documentElement.lang || "de").toLowerCase().split("-")[0];
      ober = TEXTE[l] ? l : "en";
      if (!schicht) bauen();
      document.documentElement.style.overflow = "hidden";
      schicht.classList.add("auf");
      if (angebot().length < 2) { lesen(angebot().length ? angebot()[0].code : null); }
    },
    schliessen: schliessen
  };
})();
